"use client"
import pond from '../images/pond.png'
import monsters from '../images/monsters.png'
import restaurant from '../images/restaurant.png'
import sousvide from '../images/sousvide.png'
import gufari from '../images/gufari.png'

const gifts = [
    {
        id: 1,
        name: "Pond Ferm Living",
        image: pond,
        description: "Pond spegill frá Ferm Living | Pond speil fra Ferm Living",
    },
    {
        id: 3,
        name: "Upplifun | Opplevelse",
        image: restaurant,
        description: "Gjafabréf á veitingastað | Gavekort til Restaurant",
    },
    {
        id: 4,
        name: "Sous Vide",
        image: sousvide,
        description: "Sous Vide",
    },
    {
        id: 5,
        name: "Vinyl Plötur | Plater",
        image: monsters,
        description: "Of monsters and men: My head is an animal | Adele 21 | Mezzoforte: Surprise surprise",
    },
    {
        id: 6,
        name: "Gufari | Dampmaskin",
        image: gufari,
        description: "Gufari | Dampmaskin",
    },
]

export function GiftRegistry() {
    return (
        <div style={{ backgroundColor: "#fafaf9", color: "#292524" }}>
            {/* Hero Section */}
            {/* <section
        style={{
          position: "relative",
          minHeight: "20vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(to bottom, rgba(245, 242, 238, 0.3), #fafaf9)",
          padding: "4rem 1rem",
        }}
      >
        <div style={{ maxWidth: "56rem", margin: "0 auto", textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "1rem",
              borderRadius: "9999px",
              backgroundColor: "rgba(180, 135, 94, 0.1)",
            }}
          >
            <FontAwesomeIcon icon={faGift} style={{ width: "3rem", height: "3rem", color: "#b4875e" }} />
          </div>
        </div>
        
      </section> */}

            {/* Gift Registry Links */}
            <section style={{ padding: "1rem 1rem", backgroundColor: "rgba(245, 242, 238, 0.2)" }}>
                <div style={{ maxWidth: "72rem", margin: "0 auto" }}>
                    <h2
                        style={{
                            fontFamily: "Georgia, Playfair Display, serif",
                            fontSize: "clamp(1.875rem, 5vw, 2.25rem)",
                            textAlign: "center",
                            marginBottom: "3rem",
                            color: "#292524",
                        }}
                    >
                        {/* Gjafalisti | Ønskeliste */}
                    </h2>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                            gap: "2rem",
                            maxWidth: "56rem",
                            margin: "0 auto",
                        }}
                    >
                        {/* Norway Registry */}
                        <div
                            style={{
                                backgroundColor: "white",
                                borderRadius: "0.5rem",
                                padding: "2rem",
                                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                                border: "1px solid #e7e5e4",
                                transition: "box-shadow 0.2s",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = "0 1px 3px 0 rgba(0, 0, 0, 0.1)"
                            }}
                        >
                            <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
                                <h3
                                    style={{
                                        fontFamily: "Georgia, Playfair Display, serif",
                                        fontSize: "1.5rem",
                                        color: "#292524",
                                        marginBottom: "0.75rem",
                                    }}
                                >
                                    Ønskeliste Norge
                                </h3>
                                <p style={{ color: "#78716c" }}>For de som vil handle i Norge</p>
                            </div>
                            <a
                                href="https://www.kitchn.no/onskeliste/251018/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: "block",
                                    width: "100%",
                                    padding: "0.75rem 1.5rem",
                                    backgroundColor: "#b4875e",
                                    color: "white",
                                    textAlign: "center",
                                    borderRadius: "0.375rem",
                                    textDecoration: "none",
                                    fontSize: "1rem",
                                    fontWeight: "500",
                                    transition: "background-color 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#9a7350"
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "#b4875e"
                                }}
                            >
                                Se ønskeliste fra kitchn.no
                            </a>
                        </div>

                        {/* International Registry */}
                        <div
                            style={{
                                backgroundColor: "white",
                                borderRadius: "0.5rem",
                                padding: "2rem",
                                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                                border: "1px solid #e7e5e4",
                                transition: "box-shadow 0.2s",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = "0 1px 3px 0 rgba(0, 0, 0, 0.1)"
                            }}
                        >
                            <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
                                <h3
                                    style={{
                                        fontFamily: "Georgia, Playfair Display, serif",
                                        fontSize: "1.5rem",
                                        color: "#292524",
                                        marginBottom: "0.75rem",
                                    }}
                                >
                                    Gjafalisti Íslenskur
                                </h3>
                                <p style={{ color: "#78716c" }}>Lykilorð: Trompet</p>
                            </div>
                            <a
                                href="https://www.lifoglist.is/gjafalistar/skoda/3eac0f19-6a0d-4c39-999e-aeee6e0285c0"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: "block",
                                    width: "100%",
                                    padding: "0.75rem 1.5rem",
                                    backgroundColor: "#b4875e",
                                    color: "white",
                                    textAlign: "center",
                                    borderRadius: "0.375rem",
                                    textDecoration: "none",
                                    fontSize: "1rem",
                                    fontWeight: "500",
                                    transition: "background-color 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#9a7350"
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "#b4875e"
                                }}
                            >
                                Skoða gjafalista á lifoglist.is
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Gift Gallery */}
            <section style={{ padding: "4rem 1rem", backgroundColor: "#fafaf9" }}>
                <div style={{ maxWidth: "80rem", margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: "3rem" }}>
                        <h2
                            style={{
                                fontFamily: "Georgia, Playfair Display, serif",
                                fontSize: "clamp(1.875rem, 5vw, 2.25rem)",
                                color: "#292524",
                                marginBottom: "1rem",
                            }}
                        >
                            Aðrar gjafa hugmyndir | Andre Gave idéer
                        </h2>
                        <p
                            style={{
                                fontSize: "1.125rem",
                                color: "#78716c",
                                maxWidth: "42rem",
                                margin: "0 auto",
                                lineHeight: "1.6",
                            }}
                        >
                        </p>
                    </div>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                            gap: "clamp(1.5rem, 3vw, 2rem)",
                        }}
                    >
                        {gifts.map((gift) => (
                            <div
                                key={gift.id}
                                style={{
                                    backgroundColor: "white",
                                    borderRadius: "0.5rem",
                                    overflow: "hidden",
                                    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                                    border: "1px solid #e7e5e4",
                                    transition: "all 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
                                    const img = e.currentTarget.querySelector("img")
                                    if (img instanceof HTMLElement) {
                                        img.style.transform = "scale(1.05)"
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = "0 1px 3px 0 rgba(0, 0, 0, 0.1)"
                                    const img = e.currentTarget.querySelector("img")
                                    if (img instanceof HTMLElement) {
                                        img.style.transform = "scale(1)"
                                    }
                                }}
                            >
                                <div style={{ aspectRatio: "1", overflow: "hidden", backgroundColor: "#f5f5f4" }}>
                                    <img
                                        src={gift.image || "/placeholder.svg"}
                                        alt={gift.name}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            transition: "transform 0.3s",
                                        }}
                                    />
                                </div>
                                <div style={{ padding: "1.5rem" }}>
                                    <h3
                                        style={{
                                            fontFamily: "Georgia, Playfair Display, serif",
                                            fontSize: "1.25rem",
                                            color: "#292524",
                                            marginBottom: "0.5rem",
                                        }}
                                    >
                                        {gift.name}
                                    </h3>
                                    <p style={{ color: "#78716c", fontSize: "0.875rem", lineHeight: "1.5" }}>{gift.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Thank You Section */}
            <section style={{ padding: "4rem 1rem", backgroundColor: "rgba(245, 242, 238, 0.2)" }}>
                <div style={{ maxWidth: "48rem", margin: "0 auto", textAlign: "center" }}>
                    <h2
                        style={{
                            fontFamily: "Georgia, Playfair Display, serif",
                            fontSize: "clamp(1.875rem, 5vw, 2.25rem)",
                            color: "#292524",
                            marginBottom: "1.5rem",
                        }}
                    >
                        Takk
                    </h2>
                    <p
                        style={{
                            fontSize: "1.125rem",
                            color: "#78716c",
                            lineHeight: "1.75",
                        }}
                    >
                        Við erum ótrúlega þakklát fyrir að þið ætlið að fagna með okkur.
                    </p>
                    <p
                        style={{
                            fontSize: "1.125rem",
                            color: "#78716c",
                            lineHeight: "1.75",
                        }}
                    >
                        Vi er veldig takknemlige for at dere vil feire sammen med oss.
                    </p>
                </div>
            </section>
        </div>
    )
}
